import React from 'react';
import { Link } from "react-router-dom";
import { Auth } from 'aws-amplify';

import * as MESSAGES from '../Lib/Messages';
import Spinner from './Spinner';
import Logo from './Logo';
import { API } from '../Lib/Utils';
import Notification from './Notification';
import appSyncConfig from "../AppSync";
import InputError from './InputError';
import Validator from '../Lib/Validator';
import * as Utils from '../Lib/Utils';

import { convertEmptyString } from '../Lib/Utils';
import moment from "moment";

class UserSignup extends React.Component {
	constructor(props) {
		super();
		this.state = {
			code: "",
			term: false,
			loading: false,
			errors: {},
			isError: false,
			errorMessage: null,
			step: "signup",
			signupEmail: ""
		};

		this.state = { ...this.getInitialState(), ...this.state };
		this.handleChange = this.handleChange.bind(this);
		this.handleChangePass = this.handleChangePass.bind(this);
		this.handleChangeCode = this.handleChangeCode.bind(this);
		this.handleTerm = this.handleTerm.bind(this);
	}

	getInitialState = () => ({
		password: "",
		confirm_password: "",
		user: {
			id: "",
			firstName: "",
			lastName: "",
			gender: "Male",
			email: "",
			state: "",
			birthday: "",
			mobile: "",
			address: "",
			city: "",
			country: 'Australia',
			status: "1",
			default_plan_id: appSyncConfig.default_plan_id,
			created: moment.utc().format(),
			updated: moment.utc().format()
		},
	});

	handleChange(event) {
		const { target: { name, value } } = event;
		const { user, errors } = this.state;
		user[name] = value;
		this.setState(user);
		if (errors[name]) {
			delete errors[name];
		}
	}

	handleChangePass(event) {
		const { target: { name, value } } = event;
		const { errors } = this.state;
		this.setState({ [name]: value });
		if (errors[name]) {
			delete errors[name];
		}
	}

	handleChangeCode(event) {
		const { target: { value } } = event;
		const { errors } = this.state;
		this.setState({ code: value });
		if (errors.code) {
			delete errors.code;
		}
	}

	handleTerm(event) {
		const { target: { value } } = event;
		const { errors } = this.state;
		this.setState({ term: value });

		if (errors["term"]) {
			delete errors["term"];
		}
	}

	isValidation() {
		this.setState({ errors: {}, errorMessage: '' });

		var errors = {};
		var isError = false;
		const { password, confirm_password, user } = this.state;
		var validator = new Validator();

		if (!validator.required(user.firstName)) {
			errors['firstName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if (!validator.required(user.lastName)) {
			errors['lastName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if (!validator.required(user.email)) {
			errors['email'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if (!validator.email(user.email)) {
			errors['email'] = MESSAGES.ERROR_EMAIL;
			isError = true;
		}

		if (!validator.minLength(password, 8)) {
			errors['password'] = MESSAGES.ERROR_MINLENGTH;
			isError = true;
		}
		if (!validator.required(confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if (!validator.match(password, confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_CONFIRM_PASS;
			isError = true;
		}

		if (!validator.required(user.state)) {
			errors['state'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}

		if (!this.state.term) {
			errors['term'] = "Please argee with terms of use";
			isError = true;
		}

		if (!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if (isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	componentDidMount() {
		sessionStorage.clear();
		localStorage.clear();
	}

	componentWillUnmount() {
		if (this.redirectTimer) {
			clearTimeout(this.redirectTimer);
		}
	}

	handleSignup = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if (!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true, errorMessage: null, isError: false });
		const { user, password } = this.state;
		const email = `${user.email}`.trim().toLowerCase();

		Auth.signUp({
			username: email, password: password,
			attributes: {
				email: email,
				name: user.firstName + " " + user.lastName
			}
		}).then(async data => {
			user['id'] = data.userSub;
			user['updated'] = moment.utc().format();
			user['created'] = moment.utc().format();
			var $this = this;
			const result = API('therapist', convertEmptyString(user));
			result.then(response => {
				if (response.status !== undefined && response.status === 'success') {
					$this.setState({
						errorMessage: MESSAGES.SUCCESS_USER_SIGNUP,
						isError: false,
						loading: false,
						step: 'verify',
						signupEmail: email,
						code: ''
					});
				} else {
					$this.setState({ errorMessage: MESSAGES.ERROR_USER_SIGNUP, isError: true, loading: false });
				}
			}).catch(error => {
				$this.setState({ errorMessage: MESSAGES.ERROR_USER_SIGNUP, isError: true, loading: false });
			});
		}).catch(err => {
			if (err.message) {
				this.setState({ errorMessage: err.message, isError: true, loading: false });
			} else {
				this.setState({ loading: false });
			}
		});
	}

	handleConfirm = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		const { code, signupEmail } = this.state;
		var validator = new Validator();
		if (!validator.required(code)) {
			this.setState({ errors: { code: MESSAGES.ERROR_REQUIRED } });
			return false;
		}
		if (!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			return false;
		}

		this.setState({ loading: true, errorMessage: null, isError: false, errors: {} });

		Auth.confirmSignUp(signupEmail, code.trim())
			.then(() => {
				this.setState({
					loading: false,
					errorMessage: MESSAGES.SUCCESS_USER_ACTIVATED,
					isError: false
				});
				this.redirectTimer = setTimeout(() => {
					this.props.history.push({
						pathname: '/user/signin',
						state: { message: MESSAGES.SUCCESS_USER_ACTIVATED }
					});
				}, 2000);
			})
			.catch(err => {
				const message = typeof err === 'string'
					? err
					: (err && err.message) ? err.message : MESSAGES.ERROR_USER_ACTIVATED;
				this.setState({
					loading: false,
					errorMessage: message,
					isError: true
				});
			});
	}

	renderVerify() {
		const { loading, code, errors, isError, errorMessage, signupEmail } = this.state;
		return (
			<div className="center-sign">
				<Logo />
				<div className="panel card-sign">
					<div className="card-title-sign mt-3 text-right">
						<h2 className="title text-uppercase font-weight-bold m-0">
							<i className="fa fa-user mr-1"></i>
							Verify Account
						</h2>
					</div>
					<div className={`card-body${loading ? ' loading-overlay-showing' : ''}`}>
						<Spinner />
						<form method="POST">
							<Notification isError={isError} message={errorMessage} />
							<p className="text-center">Enter the verification code sent to <strong>{signupEmail}</strong></p>
							<div className={`form-group mb-3 ${errors.code ? 'has-danger' : ''}`}>
								<label>Verification Code</label>
								<div className="input-group input-group-icon">
									<input name="code" type="text" className="form-control form-control-lg" value={code} onChange={this.handleChangeCode} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-barcode"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.code} />
							</div>
							<div className="row">
								<div className="col-sm-8">
								</div>
								<div className="col-sm-4 text-right">
									<button type="submit" className="btn btn-primary mt-2" onClick={this.handleConfirm} style={{ marginRight: 0 }}>Activate</button>
								</div>
							</div>
							<p className="text-center mt-3">
								Remembered? <Link role="menuitem" tabIndex="-1" to="/user/signin">Sign In</Link>
							</p>
						</form>
					</div>
				</div>
				<p className="text-center text-muted mt-3 mb-3">&copy; Copyright 2018. All Rights Reserved.</p>
			</div>
		);
	}

	render() {
		if (this.state.step === 'verify') {
			return this.renderVerify();
		}

		const { loading, user, errors, isError, errorMessage } = this.state;
		return (
			<div className="center-sign">
				<Logo />
				<div className="panel card-sign">
					<div className="card-title-sign mt-3 text-right">
						<h2 className="title text-uppercase font-weight-bold m-0">
							<i className="fa fa-user mr-1"></i>
							Sign Up
						</h2>
					</div>
					<div className={`card-body${loading ? ' loading-overlay-showing' : ''}`}>
						<Spinner />

						<form method="POST">

							<Notification isError={isError} message={errorMessage} />

							<div className={`form-group mb-3 ${errors.firstName ? 'has-danger' : ''}`}>
								<label>First Name</label>
								<div className="input-group input-group-icon">
									<input name="firstName" type="text" className="form-control form-control-lg" value={user.firstName} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-address-book"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.firstName} />
							</div>

							<div className={`form-group mb-3 ${errors.lastName ? 'has-danger' : ''}`}>
								<label>Last Name</label>
								<div className="input-group input-group-icon">
									<input name="lastName" type="text" className="form-control form-control-lg" value={user.lastName} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-address-book"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.lastName} />
							</div>

							<div className={`form-group mb-3 ${errors.email ? 'has-danger' : ''}`}>
								<label>Email</label>
								<div className="input-group input-group-icon">
									<input name="email" type="text" className="form-control form-control-lg" value={user.email} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-user"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.email} />
							</div>

							<div className={`form-group mb-3 ${errors.password ? 'has-danger' : ''}`}>
								<label>Password</label>
								<div className="input-group input-group-icon">
									<input name="password" type="password" className="form-control form-control-lg" value={this.state.password} onChange={this.handleChangePass} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.password} />
							</div>

							<div className={`form-group mb-3 ${errors.confirm_password ? 'has-danger' : ''}`}>
								<label>Confirm Password</label>
								<div className="input-group input-group-icon">
									<input name="confirm_password" type="password" className="form-control form-control-lg" value={this.state.confirm_password} onChange={this.handleChangePass} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.confirm_password} />
							</div>

							<div className="form-group mb-3">
								<label>Country</label>
								<div className="input-group input-group-icon">
									<select id="country" name="country" className="form-control form-control-lg" value={this.state.country} onChange={this.handleChange}>
										{Utils.COUNTRIES.map((item, i) =>
											<option key={i} value={item.country}>{item.country}</option>
										)}
									</select>
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-globe"></i>
										</span>
									</span>
								</div>
							</div>

							<div className={`form-group mb-3 ${errors.state ? 'has-danger' : ''}`}>
								<label>State</label>
								<div className="input-group input-group-icon">
									<input name="state" type="text" className="form-control form-control-lg" value={this.state.state} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-flag"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.state} />
							</div>

							<div className="row">
								<div className="col-sm-8">
									<div className="checkbox-custom checkbox-default">
										<input id="AgreeTerms" name="term" type="checkbox" value={this.state.term} onChange={this.handleTerm} />
										<label className="AgreeTerms">I agree with <a href="https://www.sensationax.com/term_condition.html" target="_blank">Terms of use</a></label>
										<InputError error={errors.term} />
									</div>
								</div>
								<div className="col-sm-4 text-right">
									<button type="submit" className="btn btn-primary mt-2" onClick={this.handleSignup} style={{ marginRight: 0 }}>Sign Up</button>
								</div>
							</div>

							<p className="text-center mt-3">
								Remembered? <Link role="menuitem" tabIndex="-1" to="/user/signin">Sign In</Link> or <Link role="menuitem" tabIndex="-1" to="/user/forgot_pwd">Lost Password</Link>
							</p>
							<br />
						</form>
					</div>
				</div>

				<p className="text-center text-muted mt-3 mb-3">&copy; Copyright 2018. All Rights Reserved.</p>
			</div>
		)
	}
}

export default UserSignup;
